export default __webpack_public_path__ + "static/pin-scroll-bg-b281e0f4ab29d735382744eae966ed9e.png";